import { render } from "./CleaveField.vue?vue&type=template&id=048553a8"
import script from "./CleaveField.vue?vue&type=script&lang=js"
export * from "./CleaveField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__